import { createReducer, on } from '@ngrx/store'
import * as transactionsActions from './txn.actions'
export interface TransactionsState {
    transactions,
    fetchTransactionsError: boolean
    loadingTransactions: boolean

    debit,
    debitLoading: boolean
    debitError: boolean

    signaturesResult,
    signaturesResultLoading: boolean
    signaturesResultError: boolean
}

export const initialState: TransactionsState = {
    transactions: null,
    fetchTransactionsError: null,
    loadingTransactions: null,

    debit: null,
    debitLoading: null,
    debitError: null,

    signaturesResult: null,
    signaturesResultLoading: null,
    signaturesResultError: null,
}

export const TransactionsReducer = createReducer(
    initialState,

    on(transactionsActions.fetchTransactions, (state) => ({
        ...state, transactions: null, fetchTransactionsError: null, loadingTransactions: true
    })),

    on(transactionsActions.fetchTransactionsSuccess, (state, {transactions}) => ({
        ...state, transactions: transactions, fetchTransactionsError: false, loadingTransactions: false
    })),

    on(transactionsActions.fetchTransactionsFailed, (state) => ({
        ...state, transactions: null, fetchTransactionsError: true, loadingTransactions: false
    })),



    on(transactionsActions.fetchDebit, (state) => ({
        ...state, debit: null, debitError: null, debitLoading: true
    })),

    on(transactionsActions.fetchDebitSuccess, (state, {debitDetails}) => ({
        ...state, debit: debitDetails, debitError: false, debitLoading: false
    })),

    on(transactionsActions.fetchDebitFailed, (state) => ({
        ...state, debit: null, debitError: true, debitLoading: false
    })),



    on(transactionsActions.checkSignatures, (state) => ({
        ...state, signaturesResult: null, signaturesResultError: null, signaturesResultLoading: true
    })),

    on(transactionsActions.checkSignaturesSuccess, (state, {signaturesResult}) => ({
        ...state, signaturesResult: signaturesResult, signaturesResultError: false, signaturesResultLoading: false
    })),

    on(transactionsActions.checkSignaturesFailed, (state) => ({
        ...state, signaturesResult: null, signaturesResultError: true, signaturesResultLoading: false
    })),

)